import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {
  DefaultPackageConfigurationFieldsType
} from "../../../site-preferences/types/default-package-configuration-fields.type";
import {SplitService} from "../../../commons/services/split-service.service";
import {PackageConfigurationService} from "../../../site-preferences/services/package-configuration-service.service";
import {FieldType} from "../../../site-preferences/types/field.type";

export class FulfillmentLinePackagesTableRowComponent implements IController {

  package: any;
  weightUnit: any;
  volumeUnit: any;
  distanceUnit: any;
  isShowSplitPackagesAction: boolean;
  packageDynamicColumns: any;
  columns: any;
  onSplitPackage: Function;

  public packageVolume: number = undefined;
  public splitType: string = undefined;
  public readonly defaultPackageConfigurationFieldsTypesMap: typeof DefaultPackageConfigurationFieldsType = DefaultPackageConfigurationFieldsType;
  public packageConfigurationByType: any;

  constructor(private splitService: SplitService, private packageConfigurationService: PackageConfigurationService) {
  }

  $onInit() {
    this.packageConfigurationByType = this.packageConfigurationService.getPackageConfigurationsBySize();
    if (!_.isUndefined(this.package.volume)) {
      this.packageVolume = this.package.volume;
    } else if (!_.isUndefined(this.package?.dimensions?.cube)) {
      this.packageVolume = this.package.dimensions.cube;
    }

    this.splitType = _.find(this.splitService.getSitePackageItems(), p => {
      return p.id === this.package.type
    })?.splitSettings?.splitType;

  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentLinePackagesTableRow', {
    bindings: {
      package: '<',
      weightUnit: '<',
      volumeUnit: '<',
      distanceUnit: '<',
      isShowSplitPackagesAction: '<',
      packageDynamicColumns: '<',
      columns: '<',
      onSplitPackage: '&'
    },
    template: require('./fulfillment-line-packages-table-row.html').default,
    controller: FulfillmentLinePackagesTableRowComponent
  });
